import React from "react";
import { classes } from "@mqd/volt-toolbox/src";
import PropTypes from "prop-types";
import { LoadingOverlay } from "../loading-overlay/index.js";
import css from "./button.module.css";
export function Button({
  children,
  link,
  fullWidth,
  loading,
  onClick,
  testId,
  type,
  mod = "primary",
  ...buttonProps
}) {
  mod = mod || type;
  function handleClick(event) {
    onClick(event);
  }
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      className: classes(
        css.button,
        css[`button--${mod}`],
        link && css[`button--link`],
        fullWidth && css[`button--full-width`],
        loading && css[`button--loading`]
      ),
      "data-testid": testId,
      onClick: handleClick,
      ...buttonProps
    },
    /* @__PURE__ */ React.createElement("span", { className: css.content }, children),
    loading && /* @__PURE__ */ React.createElement("span", { className: css.loader }, /* @__PURE__ */ React.createElement(
      LoadingOverlay,
      {
        active: loading,
        size: 20,
        testId: `${testId}-loader`,
        transparency: true
      }
    ))
  );
}
Button.propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
  link: PropTypes.bool,
  loading: PropTypes.bool,
  mod: PropTypes.oneOf(["primary", "secondary", "tertiary", "danger", "link"]),
  onClick: PropTypes.func,
  testId: PropTypes.string,
  type: PropTypes.string
};
Button.defaultProps = {
  fullWidth: false,
  link: false,
  loading: false,
  mod: "primary",
  testId: null
};
